import { api } from "./api";
import { eventKey, mergeClassroomEvents, normalizeDashboardEvent, readDashboardStorage } from "./dashboardGadgets";
import { waitForClassroomSync } from "./classroomEventSync";

export const assignmentSeriesIdentity = (raw) => {
    const event = normalizeDashboardEvent(raw);
    const key = ["batch_id", "recurrence_group_id", "repeat_group_id", "series_id"].find((name) => event[name]);
    return key ? { key, value: String(event[key]) } : null;
};

export async function deleteSharedAssignment(raw, scope = "event") {
    const event = normalizeDashboardEvent(raw);
    await waitForClassroomSync();
    if (!raw.event_id) {
        await api.post(`/children/${encodeURIComponent(event.child_id)}/classroom-dashboard/sync`, { events: [event] });
    }
    const url = `/children/${encodeURIComponent(event.child_id)}/classroom-dashboard/events/${encodeURIComponent(event.id)}`;
    const response = scope === "series" ? await api.delete(url, { params: { scope: "series" } }) : await api.delete(url);
    const saved = readDashboardStorage("shadowGroveEvents", []);
    const items = Array.isArray(saved) ? saved : [];
    const ids = new Set((response?.data?.deleted_event_ids || [event.id]).map(String));
    const next = Array.isArray(response?.data?.events) ? mergeClassroomEvents(items, response.data.events, event.child_id) : items.filter((item) => !(String(item.child_id) === event.child_id && ids.has(String(item.event_id ?? item.id))) && eventKey(item) !== eventKey(event));
    localStorage.setItem("shadowGroveEvents", JSON.stringify(next));
    window.dispatchEvent(new CustomEvent("shadowGroveEventsUpdated", { detail: next }));
    return next;
}
